import C1_note from './octave-1/C.mp3';
import D1_note from './octave-1/D.mp3';
import E1_note from './octave-1/E.mp3';
import F1_note from './octave-1/F.mp3';
import G1_note from './octave-1/G.mp3';

import A2_note from './octave-2/A.mp3';
import B2_note from './octave-2/B.mp3';
import C2_note from './octave-2/C.mp3';
import D2_note from './octave-2/D.mp3';
import E2_note from './octave-2/E.mp3';
import F2_note from './octave-2/F.mp3';
import G2_note from './octave-2/G.mp3';

import A3_note from './octave-3/A.mp3';
import B3_note from './octave-3/B.mp3';
import C3_note from './octave-3/C.mp3';
import D3_note from './octave-3/D.mp3';
import E3_note from './octave-3/E.mp3';
import F3_note from './octave-3/F.mp3';
import G3_note from './octave-3/G.mp3';

import A4_note from './octave-4/A.mp3';
import B4_note from './octave-4/B.mp3';
import C4_note from './octave-4/C.mp3';
import D4_note from './octave-4/D.mp3';
import E4_note from './octave-4/E.mp3';
import F4_note from './octave-4/F.mp3';
import G4_note from './octave-4/G.mp3';

import A5_note from './octave-5/A.mp3';
import B5_note from './octave-5/B.mp3';
import C5_note from './octave-5/C.mp3';

const sounds = {
  "120" :  C1_note,
  "115" :  D1_note,
  "110" :  E1_note,
  "105" :  F1_note,
  "100" :  G1_note,
  "95" :  A2_note,
  "90" :  B2_note,
  "85" :  C2_note,
  "80" :  D2_note,
  "75" :  E2_note,
  "70" :  F2_note,
  "65" :  G2_note,
  "60" :  A3_note,
  "55" :  B3_note,
  "50" :  C3_note,
  "45" :  D3_note,
  "40" :  E3_note,
  "35" :  F3_note,
  "30" :  G3_note,
  "25" :  A4_note,
  "20" :  B4_note,
  "15" :  C4_note,
  "10" :  D4_note,
  "5"  :  E4_note,
  "0"  :  F4_note,
  "-5" :  G4_note,
  "-10":  A5_note,
  "-15":  B5_note,
  "-20":  C5_note,
}

export default sounds;

export const realSounds = {
    "-70" :  C1_note,
    "-65" :  D1_note,
    "-60" :  E1_note,
    "-55" :  F1_note,
    "-50" :  G1_note,
    "-45" :  A2_note,
    "-40" :  B2_note,
    "-35" :  C2_note,
    "-30" :  D2_note,
    "-25" :  E2_note,
    "-20" :  F2_note,
    "-15" :  G2_note,
    "-10" :  A3_note,
    "-5" :  B3_note,
    "0"  : C3_note,
    "5"  : D3_note,
    "10" :  E3_note,
    "15" :  F3_note,
    "20" :  G3_note,
    "25" :  A4_note,
    "30" :  B4_note,
    "35" :  C4_note,
    "40" :  D4_note,
    "45" :  E4_note,
    "50" :  F4_note,
    "55" :  G4_note,
    "60" :  A5_note,
    "65" :  B5_note,
    "70" :  C5_note,
  }